import React, { Fragment } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';

import numeral from 'numeral';
import moment from 'moment';

import {
  Box,
  makeStyles,
  TableCell,
  TableRow,
  Tooltip,
  colors,
  Avatar,
  IconButton,
  Icon,
  Card,
  CardContent,
  CardHeader,
  Grid,
  Link,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableSortLabel,
  Divider,
  Typography
} from '@material-ui/core';

import DeleteRoundedIcon from '@material-ui/icons/DeleteRounded';
import EditRoundedIcon from '@material-ui/icons/EditRounded';
import BuildIcon from '@material-ui/icons/Build';
import SettingsInputHdmiIcon from '@material-ui/icons/SettingsInputHdmi';
import SettingsInputSvideoIcon from '@material-ui/icons/SettingsInputSvideo';

const useStyles = makeStyles((theme) => ({
  root: {
  },
  avatar: {
    marginRight: theme.spacing(2),
    backgroundColor: colors.grey[200]
  }
}));

const formatDecimal = (value) => {
  return numeral(value).format('0.00').replace('.', ',');
}

const formatNumber = (value, mask) => {
  return numeral(value).format(mask);
}

const formatDate = (value) => {
  if (value) {
    return moment(value).format('DD/MM/YYYY')
  } else {
    return ""
  }
}

const truncateValue = (value, size) => {
  if (value.length > size) {
    return value.substring(size - 3, 0) + '...';
  } else {
    return value;
  }
}

const LEVEL_ACCESS_HIDE = -1;
const LEVEL_ACCESS_DISABLED = 0;
const LEVEL_ACCESS_ENABLED = 1;

const Register = ({ icon, item, vision, resultMode, openEdition, openDeletion, openTreatment, dependencies, openFieldEdition }) => {

  const classes = useStyles();

  const getFieldValue = (column) => {
    try {
      var value = eval(column.field);
      return ((value) ? value : "");
    } catch (error) {
      return "";
    }
  }

  const getStyleActionsAjustment = (resultMode) => {
    var distance = (
      (resultMode.update != LEVEL_ACCESS_HIDE ? resultMode.update : LEVEL_ACCESS_DISABLED) +
      (resultMode.delete != LEVEL_ACCESS_HIDE ? resultMode.delete : LEVEL_ACCESS_DISABLED) +
      (resultMode.config != LEVEL_ACCESS_HIDE ? resultMode.config : LEVEL_ACCESS_DISABLED)) * 80;
    return { maxWidth: distance, minWidth: distance };
  }

  return (
    <Fragment>

      <Card>
        <CardHeader
          title={`Portas de Entradas: ( ` + item.inputs.length + ` )`}
        />
        <Divider />
        <CardContent>

          <TableContainer component={PerfectScrollbar}>

            <Table stickyHeader size="small" aria-label="a dense table">
              <TableHead>
                <TableRow>

                  <TableCell>
                    Porta
                  </TableCell>

                  <TableCell>
                    Nome
                  </TableCell>

                  <TableCell>
                    Unidade
                  </TableCell>

                  <TableCell>
                    Formato
                  </TableCell>

                  <TableCell>
                    Sufixo
                  </TableCell>

                  <TableCell>
                    Monitores
                  </TableCell>

                  <TableCell>
                  </TableCell>

                </TableRow>
              </TableHead>
              <TableBody>
                {item.inputs.map((item) => (
                  <TableRow hover key={item.id} >
                    <TableCell>
                      <Box
                        alignItems="center"
                        display="flex"
                        component={Link}
                        onClick={() => { openFieldEdition(item) }}
                      >
                        <Avatar
                          className={classes.avatar}
                        >
                          {<Icon component={SettingsInputSvideoIcon} style={{ color: colors.indigo[400] }} ></Icon>}
                        </Avatar>
                        {item.order}
                      </Box>
                    </TableCell>

                    <TableCell>
                      {item.name}
                    </TableCell>

                    <TableCell>
                      {item.unit}
                    </TableCell>

                    <TableCell>
                      {item.format}
                    </TableCell>

                    <TableCell>
                      {item.sufix}
                    </TableCell>

                    <TableCell>
                      {item.tests.length}
                    </TableCell>

                    <TableCell >
                      <Tooltip title="Editar porta de entrada">
                        <IconButton
                          color="secondary"
                          className={classes.btntreatment}
                          children={<EditRoundedIcon />}
                          size="medium"
                          onClick={() => { openFieldEdition(item) }}></IconButton>
                      </Tooltip>
                    </TableCell>

                  </TableRow>
                ))
                }
              </TableBody>
            </Table>
          </TableContainer>

        </CardContent>

      </Card>

      <Box spacing={3} >&nbsp;</Box>

      <Card>
        <CardHeader
          title={`Portas de Saída: ( ` + item.outputs.length + ` )`}
        />
        <Divider />
        <CardContent>

          <TableContainer component={PerfectScrollbar}>

            <Table stickyHeader size="small" aria-label="a dense table">
              <TableHead>
                <TableRow>

                  <TableCell>
                    Porta
                  </TableCell>

                  <TableCell>
                    Nome
                  </TableCell>

                  <TableCell>
                    Unidade
                  </TableCell>

                  <TableCell>
                    Formato
                  </TableCell>

                  <TableCell>
                    Sufixo
                  </TableCell>

                  <TableCell>
                    Monitores
                  </TableCell>

                  <TableCell>
                  </TableCell>

                </TableRow>
              </TableHead>
              <TableBody>
                {item.outputs.map((item) => (
                  <TableRow hover key={item.id} >

                    <TableCell>
                      <Box alignItems="center"
                        display="flex"
                        component={Link}
                        onClick={() => { openFieldEdition(item) }}>
                        <Avatar
                          className={classes.avatar}
                        >
                          {<Icon component={SettingsInputHdmiIcon} style={{ color: colors.indigo[400] }} ></Icon>}
                        </Avatar>
                        {item.order}
                      </Box>
                    </TableCell>

                    <TableCell>
                      {item.name}
                    </TableCell>

                    <TableCell>
                      {item.unit}
                    </TableCell>

                    <TableCell>
                      {item.format}
                    </TableCell>

                    <TableCell>
                      {item.sufix}
                    </TableCell>

                    <TableCell>
                      {item.tests.length}
                    </TableCell>

                    <TableCell >
                      <Tooltip title="Editar porta de saída">
                        <IconButton
                          color="secondary"
                          className={classes.btntreatment}
                          children={<EditRoundedIcon />}
                          size="medium"
                          onClick={() => { openFieldEdition(item) }}></IconButton>
                      </Tooltip>
                    </TableCell>

                  </TableRow>
                ))
                }
              </TableBody>
            </Table>
          </TableContainer>

        </CardContent>

      </Card>

    </Fragment>
  );
}

export default Register;